<template>
  <div
    v-if="show"
    class="info__modal-overlay"
    @click="closeModal"
  >
    <div
      class="info__modal"
      @click.stop
    >
      <div class="info__modal-wrapper">
        <div class="info__modal-head">
          <h3 class="info__modal-head-title">
            {{ modalData.name }}
          </h3>

          <v-btn
            @click="closeModal"
            class="info__modal-close-btn"
            icon="mdi mdi-close"
            variant="text"
            aria-label="Zamknij okno"
          />
        </div>

        <div class="info__modal-scroll-container">
          <div class="info__modal-scroll-content">
            <div
              class="modal-desc"
              v-html="modalData.description"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed, defineComponent, Ref,
} from 'vue';
import store from '@/store/index';
import { IInfoModalData } from '@/interfaces/IInfoModalData';

const InfoModal: object = defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
      name: 'show',
    },
  },
  
  setup() {
    const closeModal = () => {
      store.commit('closeInfoModal');
    };
    const modalData: Ref<IInfoModalData> = computed(() => store.state.otherModals.infoModal.data);

    return {
      modalData,
      closeModal,
    };
  },
});
export default InfoModal;
</script>

<style lang="scss">
  .info__modal {
    font-family: $main-font-family;
    position: absolute;
    width: 1200px;
    max-width: 100%;
    height: calc(90vh - 82px);
    padding: rem(25px) rem(5px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
    border-radius: rem(9px);
    color: $main-font-color;
    background-color: $main-bg-color;
    border: rem(2px) solid rgba(#F1F1F1, 0.97);
    box-shadow: 0 0 10px 0px rgba(#000000, 0.3);
    height: calc(90vh - 82px);

    @include width-until($mobile) {
      top: 50%;
      transform: translate(-50%, -50%);
    }

    &-overlay {
      position: fixed;
      inset: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.4);
      z-index: 101;
    }

    .dark-theme & {
      background-color: $dark-static;
      border: rem(2px) solid $yellow-static;
    }

    &-wrapper {
      display: flex;
      flex-flow: column;
      height: 100%;

      @include width-until($mobile) {
        padding-top: 20px;
      }
    }

    &-head {
      padding: 0 rem(18px);
      margin-bottom: 16px;

      @include width-until($mobile) {
        padding: 0 rem(6px);
      }

      &-title {
        font-size: rem(26px);
        font-weight: 700;
        letter-spacing: 1px;
        margin-bottom: 4px;
      }
    }

    &-scroll-container {
      overflow: auto;
      height: 100%;
    }

    &-scroll-content {
      padding: 0 rem(18px);
    }

    &-close-btn {
      position: absolute;
      top: rem(8px);
      right: rem(10px);
      border-radius: 50%;
      height: rem(24px);
      width: rem(24px);
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      i {
        color: $main-font-color;
        font-weight: 600;
        font-size: rem(34px);
      }
    }
  }

  .event-list {
    &__date {
      margin-bottom: rem(14px);
      font-size: rem(14px);
    }

    &__calendar-filter {
      margin-left: auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      &-box {
        max-width: 140px;
      }
    }

    &__day {
      margin-bottom: rem(20px);
    }

    &__filters-wrapper {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    &__kind-filter {
      &-btn {
        margin-right: 5px;
        margin-bottom: 10px;
        margin-top: 10px;
        position: relative;

        &.--inactive {
          background-color: grey !important;
        }

        i {
          font-size: rem(20px);
        }

        &:hover {
          @include width-from($mobile) {
            .event-list__kind-filter-label {
              opacity: 1;
              pointer-events: auto;
            }
          }
        }

        &-icon {
          background: currentColor;
          width: 26px;
          height: 22px;
        }
      }

      &-label {
        word-wrap: break-spaces;
        letter-spacing: rem(0.7px);
        font-weight: 500;
        line-height: 0.875;
        white-space: nowrap;
        padding: rem(4px) rem(8px);
        border-radius: rem(14px);
        transition: .5s;
        color: $main-font-color;
        background-color: $main-bg-color;
        pointer-events: none;
        font-size: rem(10px);
        font-weight: 700;
        border: 1px solid $main-bg-color;
        z-index: 2;
        bottom: -32px;
        left: 50%;
        transform: translateX(-50%);

        &:hover {
          text-decoration: none;
        }

        @include width-from($mobile) {
          position: absolute;
          opacity: 0;
        }

        @include width-until($mobile) {
          color: $main-font-color;
          background-color: $main-bg-color;
          display: none;
        }
      }
    }
  }

  .text-green input{
    color: green !important;
  }

</style>
